import {CommonModule} from '@angular/common';
import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {IonicModule} from '@ionic/angular';

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, IonicModule],
  selector: 'app-new-patient-modal',
  templateUrl: './new-patient-modal.component.html',
  styleUrls: ['./new-patient-modal.component.scss']
})
export class NewPatientModalComponent implements OnInit {
  @Input() payload: any;
  @Output() closed: EventEmitter<{accepted: boolean; choice?: string | null}> = new EventEmitter();

  choice: string | null = null;
  fiscalCode: string = '';

  get hasMatchingPatients(): boolean {
    return !!(this.payload && Array.isArray(this.payload.choices) && this.payload.choices.length > 0);
  }

  ngOnInit(): void {
    this.fiscalCode = (this.payload?.assistantResponse?.content as any)?.fiscalCode || '';
  }

  onSelect(choice: string) {
    this.choice = choice;
    // if user selects an existing mapping and fiscalCode is empty, populate it
    const mapped = this.payload?.choicesMapping?.[choice];
    if ((!this.fiscalCode || this.fiscalCode.trim() === '') && mapped) {
      this.fiscalCode = mapped;
    }
  }

  onConfirm() {
    const mapped = this.choice ? (this.payload?.choicesMapping?.[this.choice] ?? this.choice) : null;
    const fc = (this.fiscalCode && this.fiscalCode.trim()) ? this.fiscalCode.trim() : (mapped ?? null);
    this.closed.emit({accepted: true, choice: fc ?? null});
  }

  onCancel() {
    this.closed.emit({accepted: false, choice: null});
  }
}
